import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { start } from 'data/app/actions'
import {
  isBootstrapped,
  bootstrapError as getBootstrapError,
} from 'data/app/selectors'
import { getOrganizationFetchError } from 'data/organizations/selectors'

import UnknownError from 'components/Errors/Unknown'
import OrganizationNotFound from 'components/Errors/OrganizationNotFound'
import AppLoading from './Layout/AppLoading'
import Document from './Document'

function App({ children }) {
  const isPublic =
    window.location.pathname.startsWith('/public') ||
    window.location.pathname.startsWith('/p/')
  const isAutoSignin = window.location.pathname.includes('/auth/autoSignIn')
  const isResetPassword = window.location.pathname.includes(
    '/auth/reset-password'
  )

  const dispatch = useDispatch()
  const bootstrapped = useSelector(isBootstrapped)
  const bootstrapError = useSelector(getBootstrapError)
  const organizationError = useSelector(getOrganizationFetchError)

  React.useEffect(
    function startOnMount() {
      dispatch(start({ skipAuth: isPublic || isAutoSignin || isResetPassword }))
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  if (organizationError) {
    return <OrganizationNotFound />
  }

  if (bootstrapError) {
    return <UnknownError title="We failed to load your data" />
  }

  if (!bootstrapped && !isPublic) {
    return <AppLoading />
  }

  return <Document isPublic={isPublic}>{children}</Document>
}

export default React.memo(App)
